import { ConfirmModalContent, Modal } from "@ucchub/ui";

interface ConfirmChangesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
  cancelBtnText?: string;
  confirmBtnText?: string;
  title?: string;
  body?: string;
  loading?: boolean;
  heading: string;
  message: string;
}

const ConfirmModal = ({
  isOpen,
  onClose,
  onCancel,
  onConfirm,
  body,
  cancelBtnText,
  confirmBtnText,
  message,
  heading,
  loading,
}: ConfirmChangesModalProps) => {
  return (
    <Modal
      srName="back-to-quote_discard"
      isOpen={isOpen}
      isClosable
      size={2}
      animate
      onClose={onClose}
    >
      <ConfirmModalContent
        heading={heading || "Confirm changes"}
        message={message || "Confirm message"}
        body={body}
        cancelMessage={cancelBtnText || "Cancel"}
        confirmMessage={confirmBtnText || "Submit"}
        onConfirm={onConfirm}
        onCancel={onCancel}
        loading={loading}
      />
    </Modal>
  );
};

export default ConfirmModal;
